import React, { useEffect, useState } from "react";
import { Trophy, AlertTriangle, Inbox } from "lucide-react";
import api from "@/lib/api";

export default function Reports() {
  const [team, setTeam] = useState([]);
  const [dash, setDash] = useState(null);

  useEffect(() => {
    api.get("/reports/team").then(({ data }) => setTeam(data));
    api.get("/dashboard").then(({ data }) => setDash(data));
  }, []);

  return (
    <div data-testid="reports-page" className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-semibold text-slate-900">Reports</h1>
        <p className="text-slate-500 text-sm">Conversion, team performance & win/loss</p>
      </div>

      {dash && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <Stat label="Conversion Rate" value={`${dash.conversion_rate}%`} tone="text-blue-600" />
          <Stat label="Won Deals" value={dash.won} tone="text-green-600" />
          <Stat label="Lost Deals" value={dash.lost} tone="text-slate-500" />
          <Stat label="Won Value" value={`₹${(dash.won_value / 100000).toFixed(1)}L`} tone="text-violet-600" />
        </div>
      )}

      <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-slate-200">
          <h3 className="font-display text-lg font-medium">Team Performance</h3>
          <p className="text-xs text-slate-500">Who has pending actions & overdue tasks</p>
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <th className="text-left font-medium py-3 px-5">Member</th>
              <th className="text-left font-medium py-3 px-4">Role</th>
              <th className="text-center font-medium py-3 px-4">Total</th>
              <th className="text-center font-medium py-3 px-4">Won</th>
              <th className="text-center font-medium py-3 px-4">Needs Action</th>
              <th className="text-center font-medium py-3 px-4">Overdue</th>
            </tr>
          </thead>
          <tbody>
            {team.map((t, i) => (
              <tr key={i} className="border-b border-slate-100" data-testid={`team-row-${i}`}>
                <td className="py-3 px-5 font-medium text-slate-900">{t.name}</td>
                <td className="py-3 px-4 capitalize text-slate-600">{t.role}</td>
                <td className="py-3 px-4 text-center">{t.total}</td>
                <td className="py-3 px-4 text-center text-green-600 font-semibold">{t.won}</td>
                <td className="py-3 px-4 text-center">
                  {t.needs_action > 0 ? <span className="text-amber-600 font-semibold">{t.needs_action}</span> : <span className="text-slate-400">0</span>}
                </td>
                <td className="py-3 px-4 text-center">
                  {t.overdue > 0 ? <span className="text-red-600 font-semibold">{t.overdue}</span> : <span className="text-slate-400">0</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Stat = ({ label, value, tone }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm">
    <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">{label}</p>
    <p className={`mt-2 text-3xl font-bold tracking-tighter font-display ${tone}`}>{value}</p>
  </div>
);
